import React, { useState } from "react";

import SymbolSearch from "./SymbolSearch";
import { INTERVALS } from "../lib/workspace";

const Toolbar = ({ interval, theme, onSymbol, onInterval, onTheme }) => {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard blocked — the URL is still in the address bar */
    }
  };

  return (
    <header className="toolbar">
      <div className="toolbar__brand">
        <a
          href="https://jasonmark.dev"
          className="toolbar__mark"
          title="jasonmark.dev"
        >
          JM
        </a>
        <span className="toolbar__title">Terminal</span>
      </div>

      <SymbolSearch onSelect={onSymbol} />

      <div className="toolbar__group" role="group" aria-label="Interval">
        {INTERVALS.map((item) => (
          <button
            key={item.value}
            type="button"
            className={`chip${interval === item.value ? " chip--on" : ""}`}
            onClick={() => onInterval(item.value)}
          >
            {item.label}
          </button>
        ))}
      </div>

      <div className="toolbar__right">
        <button
          type="button"
          className="chip"
          onClick={() => onTheme(theme === "dark" ? "light" : "dark")}
          title="Toggle chart theme"
        >
          {theme === "dark" ? "Dark" : "Light"}
        </button>

        <button type="button" className="chip chip--primary" onClick={share}>
          {copied ? "Copied" : "Share"}
        </button>
      </div>
    </header>
  );
};

export default Toolbar;
